import { Button, Typography } from '@material-ui/core'
import { CloudDownloadOutlined, CloudUploadOutlined } from '@material-ui/icons'
import React from 'react'
import { useAlert } from '../../../../hooks/useAlert';
import withServices from '../../../../hocs/withServices';

const PaymentCheckUpload = ({ services, contract, fetchContract }) => {
    const showAlert = useAlert();

    const downloadFile = (fileId) => {
        services.fileUpload.getDocument(fileId, 'Чек об оплате');
    }

    const uploadFile = (file) => {
        services.dormContract.uploadPaymentCheck(file)
            .then(() => {
                showAlert('Чек об оплате успешно загружен', 'success');
                fetchContract();
            })
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            marginTop: '30px',
            marginBottom: '30px'
        }}>
            <Typography variant="h5">Прикрепите чек об оплате для проживания в общежития</Typography>

            <Typography variant="h6">Ваш номер договора: {contract?.contractNumber}</Typography>


            <div style={{ display: 'flex', gap: '10px' }}>
                {contract?.approved !== true && (
                    <>
                        <input
                            id="contained-button-file"
                            multiple
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => uploadFile(e.target.files[0])}
                        />
                        <label htmlFor="contained-button-file">
                            <Button variant="contained" color="primary" component="span">
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <CloudUploadOutlined />
                                    Загрузить чек об оплате
                                </div>
                            </Button>
                        </label>
                    </>)
                }


                {contract?.paymentCheckId && (
                    <Button variant="contained" onClick={() => downloadFile(contract.paymentCheckId)}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <CloudDownloadOutlined />
                            Скачать чек об оплате
                        </div>
                    </Button>
                )}
            </div>
        </div>
    )
}

export default withServices()(PaymentCheckUpload)